import { useEffect, useRef } from "react";
import { useDrag } from "react-dnd";
import { useSelector } from "react-redux";
import dragImage from "../../../../../../assets/images/svgs/drag-handle-dots-1-svgrepo-com.svg";
import CopyTextBtn from "../../../../../../components/copyTextBtn/CopyTextBtn";
import Loader from "../../../../../../components/loader/Loader";
import TextWrapper from "../../../../../../components/textWrapper/TextWrapper";
import { defaultProfileImage } from "../../../../../../constants/defaultUserImage";
import styles from "./onePlayer.module.css";

const ITEM_TYPE = "player";

const OnePlayer = ({
  player,
  tableId,
  playerIndex,
  isSelected,
  isChecked = false,
  isCheckUpdating = false,
  onToggleChecked,
}) => {
  const { rolePermissions } = useSelector((state) => state.user);
  const dragHandleRef = useRef(null);
  const playerRef = useRef(null);
  const canUpdateTables = rolePermissions.includes("update-tables");

  const [{ isDragging }, drag, dragPreview] = useDrag({
    type: ITEM_TYPE,
    item: {
      kind: "user",
      userId: player?.userId || player?._id,
      tableId,
    },
    canDrag: () => rolePermissions.includes("update-tables"),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  useEffect(() => {
    if (dragHandleRef.current) {
      drag(dragHandleRef);
    }
    if (playerRef.current) {
      dragPreview(playerRef);
    }
  }, [drag, dragPreview]);

  return (
    <div
      className={`${styles.playerContainer} ${
        isSelected ? styles.highlightedPlayer : ""
      } ${isChecked ? styles.checkedPlayer : ""}`}
      style={{ opacity: isDragging ? 0.65 : 1 }}
      id={`player-${player?.rowId || player?._id}`}
      data-player-id={player?.rowId || player?._id}
      data-player-kind="user"
      data-table-id={tableId}
      ref={playerRef}
    >
      <div className={styles.playerRightSide}>
        <img
          ref={dragHandleRef}
          src={dragImage}
          alt="drag"
          className={styles.dragHandle}
          data-no-select-box
        />
        <div className={styles.playerIndexWrapper}>
          <TextWrapper textStyle={"textMid"}>{playerIndex + 1}</TextWrapper>
        </div>

        <div className={styles.imageWrapper}>
          {player?.userImage?.path || player?.userImagePath ? (
            <img src={player?.userImage?.path || player?.userImagePath} alt="user" />
          ) : (
            <img src={defaultProfileImage} alt="user" />
          )}
        </div>
        <div className={styles.namesWrapper}>
          <div className={styles.nameRow}>
            <TextWrapper textStyle={"textSmall"}>{player?.name}</TextWrapper>
            {player?.winsCount > 0 && (
              <span className={styles.winsBadge}>
                {player.winsCount} {player.winsCount === 1 ? "فوز" : "فوز"}
              </span>
            )}
          </div>
          <div className={styles.uniqueNameWrapper}>
            <TextWrapper textStyle={"textSmall"}>{player?.gameName}</TextWrapper>
          </div>
        </div>
      </div>

      <div className={styles.playerLeftSide}>
        <div
          className={styles.checkControl}
          data-no-select-box
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => event.stopPropagation()}
        >
          {isCheckUpdating ? (
            <Loader size={18} />
          ) : (
            <input
              type="checkbox"
              checked={isChecked}
              title={isChecked ? "الغاء تحديد اللاعب" : "تحديد اللاعب"}
              disabled={!canUpdateTables}
              onChange={(event) => onToggleChecked?.(event.target.checked)}
            />
          )}
        </div>
        <TextWrapper textStyle={"textMid"}>{player?.gameId}</TextWrapper>
        <CopyTextBtn getText={() => player?.gameId} />
      </div>
    </div>
  );
};

export default OnePlayer;
